import { t } from 'i18n';
import React from 'react';
import Link from 'next/link';
import { EmptyState } from '@teko/ecommerce/mobile';
import { useRouter } from 'next/router';
import { Notification as Noti } from '@teko/notification';
import { MiniNotificationItem } from './desktop/organisms/MiniNotificationItem';
import { PageStatus, useNotification } from 'contexts';
import { Flex, Shape, styled } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';

const Wrapper = styled(Shape)`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  width: 384px;
`;
const LastLinkWrapper = styled(Flex)`
  a {
    color: #a7abc3;
    text-decoration: none;
    &:hover {
      color: #82869e;
    }
  }
`;

const Title = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 24px;
  color: #82869e;
  padding: 10px 16px;
  background-color: #f8f8fc;
`;
export interface MiniNotificationProps {
  onHide?: () => void;
}
export const MiniNotification: React.FunctionComponent<
  MiniNotificationProps
> = ({ onHide }: MiniNotificationProps) => {
  const {
    notifications,
    promotions,
    handleNotificationClicked,
    loading,
    status,
  } = useNotification();
  const router = useRouter();
  if (status === PageStatus.EMPTY && !loading && false) {
    return (
      <Wrapper backgroundColor="white" borderRadius="l" padding="s8">
        <EmptyState text={t('Bạn chưa có thông báo mới')} />
      </Wrapper>
    );
  }
  return (
    <Wrapper backgroundColor="white" borderRadius="l">
      {!!promotions.length && (
        <>
          <Title>{t('KHUYẾN MÃI')}</Title>
          {promotions.slice(0, 3).map((promotion: any) => (
            <MiniNotificationItem
              key={promotion.id}
              title={promotion.label}
              message={promotion.subLabel}
              isRead={true}
              onClick={() => {
                if (promotion.url) {
                  onHide && onHide();
                  router.push(promotion.url);
                }
              }}
              avatar={promotion.imageUrl}
            />
          ))}
        </>
      )}
      {!!notifications.length && (
        <>
          <Title>{t('ĐƠN HÀNG')}</Title>
          {notifications.slice(0, 3).map((notification: Noti) => {
            if (notification) {
              return (
                <MiniNotificationItem
                  key={notification.id}
                  title={notification.title}
                  message={notification.message}
                  isRead={notification.is_read}
                  onClick={async () => {
                    onHide && onHide();
                    await handleNotificationClicked(notification);
                    if (notification.deepLink) {
                      router.push(notification.deepLink);
                    } else if (notification.order) {
                      router.push(
                        {
                          pathname: `/account/orders/[orderId]`,
                          query: {
                            orderId: notification.order.orderId,
                          },
                        },
                        {
                          pathname: `/account/orders/${notification.order.orderId}`,
                        },
                      );
                    }
                  }}
                  time={notification.created_at}
                  avatar={
                    !notification.order
                      ? notification.image_url
                      : notification.order.imageUrl
                  }
                />
              );
            }
          })}
        </>
      )}
      <LastLinkWrapper padding="s8" align="center" justify="center">
        <Link
          href="/notification"
          as="/notification"
          onClick={onHide}
          prefetch={false}
          {...getTrackingData({
            isTrackContent: true,
            regionName: 'MiniNotification',
            contentName: 'viewNotificationFromMiniNotification',
            target: 'Notification',
          })}
        >
          {t('Xem tất cả thông báo')}
        </Link>
      </LastLinkWrapper>
    </Wrapper>
  );
};
